import { Alert, Button, Card, Form, Input, Row, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { fullWidthStyle, titleStyle } from "../constants/style";
import { useContext, useState } from "react";
import { SubmitStatus } from "../api/work-order-api";
import ApiContext from "../api/context";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Paragraph from "antd/es/typography/Paragraph";
import isValidPasssword from "../constants/password";

export default function () {
  const [password, setPassword] = useState<string>("");
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const [error, setError] = useState("");
  const { api } = useContext(ApiContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { invitationId } = useParams();
  const hasValidPassword = password !== "" && password.length > 7;
  const isSubmitting = submitStatus === SubmitStatus.Submitting;

  const parsedInvitationId = Number.parseInt(invitationId ?? "");
  const isParsedInvitationIdNotANumber = Number.isNaN(parsedInvitationId);
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") ?? "";
  const hasValidParameters = token && !isParsedInvitationIdNotANumber;

  const canSubmit = hasValidParameters &&
    submitStatus === SubmitStatus.Idle &&
    hasValidPassword;
  return (
    <div style={{ position: "fixed", width: "100%", height: "100vh" }}>
      <Title />
      <Row justify="center">
        <Spin spinning={isSubmitting}>
          <Card style={{ width: "400px" }}>
            <Title style={titleStyle} level={4}>
              Welcome to Tiller
            </Title>
            <Paragraph>
              Enter a new password to accept your invitation and create a new Tiller account.
            </Paragraph>
            <Paragraph>
              <span><b>Password Complexity Requirements</b></span>
              <ul>
                <li>Must be at least 8 characters in length.</li>
                <li>Must be no more than 64 characters in length.</li>
                <li>Must have at least one uppercase character.</li>
                <li>Must have at least one lowercase character.</li>
                <li>Must have at least one special character (!, ?, %, etc).</li>
              </ul>
            </Paragraph>
            <Form
              title="Response to Invitation"
              name="response-to-invitation"
              layout="vertical"
              colon={false}>
              <Form.Item label="New Password">
                <Input
                  placeholder="Enter your new password"
                  type="password"
                  disabled={isSubmitting}
                  onChange={e => {
                    if (submitStatus === SubmitStatus.Failed) {
                      setSubmitStatus(SubmitStatus.Idle);
                      setError("")
                    }
                    setPassword(e.target.value)
                  }}
                />
              </Form.Item>
              <Row style={fullWidthStyle} justify="end">
                <Button
                  type="primary"
                  disabled={!canSubmit}
                  onClick={() => {
                    const isValidPassword = isValidPasssword(password);
                    if (!isValidPassword) {
                      setError("Password must be at least 8 characters long, no more than 64 characters long, and must contain a lowercase character, an uppercase character, and a special symbol.");
                      setSubmitStatus(SubmitStatus.Failed);
                      return;
                    }

                    setSubmitStatus(SubmitStatus.Submitting);
                    setError("");
                    api?.putInvitation(parsedInvitationId, token, password).then(invitationResponse => {
                      const isGood = invitationResponse.good();
                      if (isGood) {
                        navigate("/login");
                        return;
                      }

                      setError("Failed to accept the invitation.");
                      setSubmitStatus(SubmitStatus.Failed);
                    }).catch(() => {
                      setError("Failed to accept the invitation.");
                      setSubmitStatus(SubmitStatus.Failed);
                    });
                  }}>
                  Accept
                </Button>
              </Row>
            </Form>
          </Card>
          {
            submitStatus !== SubmitStatus.Failed ? undefined :
              <Alert
                type="error"
                message={error}
                style={{ width: "400px", marginTop: "10px" }}
              />
          }
          {
            hasValidParameters ? undefined :
              <Alert
                type="error"
                message="The invitation link is invalid."
                style={{ width: "400px", marginTop: "10px" }}
              />
          }
        </Spin>
      </Row>
    </div>
  );
}